module.exports = __webpack_public_path__ + "static/img/ao.8b6f2ec2.svg";